export enum TokenType {
  API = "API",
  UI = "UI"
}
